import * as tslib_1 from "tslib";
import { FormArray, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LinkGroupsComponent } from './link-groups/link-groups.component';
var TabGroupComponent = /** @class */ (function () {
    function TabGroupComponent(matDialog) {
        this.matDialog = matDialog;
        this.searchInput = new FormControl();
    }
    TabGroupComponent.prototype.linkGroups = function () {
        var _this = this;
        var linkGroupsDialog = this.matDialog.open(LinkGroupsComponent, {
            panelClass: ['dialog-users'],
            data: this.linkedGroups.value
        });
        linkGroupsDialog.afterClosed().subscribe(function (groupsControl) {
            var e_1, _a;
            if (groupsControl && groupsControl.length) {
                try {
                    for (var groupsControl_1 = tslib_1.__values(groupsControl), groupsControl_1_1 = groupsControl_1.next(); !groupsControl_1_1.done; groupsControl_1_1 = groupsControl_1.next()) {
                        var groupControl = groupsControl_1_1.value;
                        _this.linkedGroups.setControl(_this.linkedGroups.value.length, groupControl);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (groupsControl_1_1 && !groupsControl_1_1.done && (_a = groupsControl_1.return)) _a.call(groupsControl_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    };
    return TabGroupComponent;
}());
export { TabGroupComponent };
